import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const loadPath = (
  languages: string | string[],
  namespaces: string | string[],
) => {
  const language = Array.isArray(languages) ? languages[0] : languages;
  const namespace = Array.isArray(namespaces) ? namespaces[0] : namespaces;

  return new URL(
    `./static/locales/${language}/${namespace}.json`,
    import.meta.url,
  ).href;
};

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: 'vi',
    fallbackLng: 'vi',
    supportedLngs: ['vi'],
    ns: ['common', 'rtdb'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath,
    },
  });

export default i18n;
